import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import {Alert, Button, TextField} from '@betareader/design-system';

import { useSelector } from 'react-redux';

import { withTranslation, Trans } from 'react-i18next';

import firebase from '../../config/fire';

export const BasicSignIn = ({
  emailLocked,
  defaultEmail,

  t,
}) => {
  const user = useSelector(state => state.user.user);
  const [email, setEmail] = useState(defaultEmail);
  const [errorMessage, setErrorMessage] = useState();
  const [password, setPassword] = useState('');

  const getRedirectResult = async () => {
    firebase
      .auth()
      .getRedirectResult()
      .then(result => {
        if (result.credential) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // const token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        localStorage.removeItem('sign-in-mode');
      })
      .catch(error => {
        // Handle Errors here.
        // const errorCode = error.code;
        // The email of the user's account used.
        // const { email } = error;
        // The firebase.auth.AuthCredential type that was used.
        // const credential = error.credential;
        // ...
        setErrorMessage(error.message);
      });
  };

  useEffect(() => {
    getRedirectResult();
  }, []);

  const passwordChanged = event => {
    setPassword(event.target.value);
    setErrorMessage(undefined);
  };

  const emailChanged = event => {
    setEmail(event.target.value);
    setErrorMessage(undefined);
  };

  const signIn = type => {
    switch (type) {
      case 'email':
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .catch(error => {
            // Handle Errors here.
            // const errorCode = error.code;
            setErrorMessage(error.message);
          });
        return;
      case 'google':
        var provider = new firebase.auth.GoogleAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(result => {
            window.location.reload();
          });
        break;
      case 'facebook':
        var provider = new firebase.auth.FacebookAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(result => {
            window.location.reload();
          });
        break;
      case 'twitter':
        var provider = new firebase.auth.TwitterAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(result => {
            window.location.reload();
          });
        break;
      default:
    }
  };

  const validateForm = () => {
    const valid =
      password.length > 6 && Boolean(email?.trim());
    return valid;
  };

  if (user && !user.isAnonymous) {
    return <div>Signed in with {user.email}</div>;
  }
  return (
    <form onSubmit={event => {
      event.preventDefault();
      if (validateForm()) signIn('email');
    }} style={{display: 'grid', gap: 'var(--br-space-3)'}}>
      {errorMessage && <Alert variant='error'>{errorMessage}</Alert>}
      <TextField id='basic-sign-in-email' label={t('Email')}
        type='email' autoComplete='email' value={email || ''}
        readOnly={emailLocked} onChange={emailChanged} />
      <TextField id='basic-sign-in-password' label={t('Password')}
        type='password' autoComplete='current-password'
        value={password} onChange={passwordChanged} />
      <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center',
        gap: 'var(--br-space-2)'}}>
        <Button type='submit' disabled={!validateForm()}>{t('SignIn')}</Button>
        <span>{t('OrUse')}</span>
        <Button variant='secondary' size='small' aria-label='Facebook'
          onClick={() => signIn('facebook')}>Facebook</Button>
        <Button variant='secondary' size='small' aria-label='Google'
          onClick={() => signIn('google')}>Google</Button>
      </div>
      <Trans i18nKey='ForgotPasswordPrompt'>
        <div style={{fontSize: '0.9em'}}>
          Forgot your password?{' '}
          <strong><a href={`${window.location.protocol}//${window.location.host}/reset-password`}>
            Reset it here!
          </a></strong>
        </div>
      </Trans>
      <Trans i18nKey='CreateAccountdPrompt'>
        <div style={{fontSize: '0.9em'}}>
          Do you not have an account?{' '}
          <strong><a href={`${window.location.protocol}//${window.location.host}/signup?redirect=${encodeURIComponent(
            window.location.pathname + window.location.search
          )}`}>
            Create one here!
          </a></strong>
        </div>
      </Trans>
    </form>
  );
};

export default withTranslation()(withRouter(BasicSignIn));
